import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo_large from "../../assets/Images/altruistlarge_logowhite.png";
import { useFormik } from "formik";
import { InputAdornment, TextField, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { otpGenerate, otpVerify } from "../../services/authService";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  setisLoginUser,
  setLoader,
  setToken,
  setUserData,
} from "../../redux/features/authSliceandSidebar";
import { common_axios } from "../../App";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [timer, setTimer] = useState(10);
  const [otpSent, setOtpSent] = useState(false);

  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin);

  // useEffect(() => {
  //   if (localStorage.getItem("token") != null) {
  //     dispatch(setUserData(JSON.parse(localStorage.getItem("user"))));
  //     dispatch(setisLoginUser(true));
  //     dispatch(setToken(localStorage.getItem("token")));
  //     common_axios.defaults.headers.common[
  //       "Authorization"
  //     ] = `Bearer ${localStorage.getItem("token")}`;
  //     common_axios.defaults.headers.common["userId"] =
  //       localStorage.getItem("userId");
  //     common_axios.defaults.headers.common["jwtToken"] =
  //       localStorage.getItem("token");
  //     common_axios.defaults.headers["source"] = "1";
  //     common_axios.defaults.headers["appVersion"] = "0";
  //     navigate("/trips");
  //   } else {
  //     dispatch(setisLoginUser(false));
  //     localStorage.clear();
  //   }
  // }, [isLogin]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    const roleIdRaw = localStorage.getItem("roleId");

    // Check token validity
    if (token && token !== "null" && token !== "undefined") {
      try {
        const userData = JSON.parse(user);
        const roleId = JSON.parse(roleIdRaw);

        if (!userData || !roleId) {
          throw new Error("Invalid user or role data in localStorage.");
        }

        // Dispatch to Redux
        dispatch(setUserData(userData));
        dispatch(setisLoginUser(true));
        dispatch(setToken(token));

        // Set axios headers
        common_axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        common_axios.defaults.headers.common["userId"] = localStorage.getItem("userId");
        common_axios.defaults.headers.common["jwtToken"] = token;
        common_axios.defaults.headers["source"] = "1";
        common_axios.defaults.headers["appVersion"] = "0";

        // Navigate based on role
        if (roleId === 1 || roleId === 2 || roleId === 5) {
          navigate("/dshbd");
        } else if (roleId === 3) {
          navigate("/addFuelDetails");
        } else if (roleId === 4) {
          navigate("/trips");
        } else {
          toast.error("Invalid role. Contact admin.");
          localStorage.clear();
          dispatch(setisLoginUser(false));
        }

      } catch (error) {
        console.error("Error processing login from localStorage:", error);
        localStorage.clear();
        dispatch(setisLoginUser(false));
      }
    } else {
      dispatch(setisLoginUser(false));
      localStorage.clear();
    }
  }, [isLogin]);


  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("user", "sfsdfsdf");
    localStorage.setItem("token", "sfsdfsdf");
    // Add your login logic here
    navigate("/staff"); // Navigate to staff page after login
  };

  const formik = useFormik({
    initialValues: {
      usernameOrEmail: "",
      password: "",
      otp: "",
      otpgen: false,
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      setLoader(true);
      await otpGenerate(values).then((res) => {
        setLoader(true);

        if (res && res.data.statusDescription.statusCode == 200) {
          formik.setFieldValue("otpgen", true);
          toast.success(res.data.statusDescription.description);
          setTimer(60);
          setOtpSent(true);
        } else if (res && res.data.statusDescription.statusCode == 201) {
          localStorage.setItem("user", JSON.stringify(res.data.userDetail));
          dispatch(setUserData(res.data.userDetail));
          dispatch(setisLoginUser(true));
          dispatch(setToken(res.data.userDetail.userTokenDetail.jwtToken));

          common_axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${res.data.userDetail.userTokenDetail.jwtToken}`;
          common_axios.defaults.headers.common["userId"] =
            res.data.userDetail.userId;
          common_axios.defaults.headers.common["jwtToken"] =
            res.data.userDetail.userTokenDetail.jwtToken;
          common_axios.defaults.headers["source"] = "1";
          common_axios.defaults.headers["appVersion"] = "0";

          localStorage.setItem(
            "userId",
            JSON.stringify(res.data.userDetail.userId)
          );
          localStorage.setItem(
            "token",
            res.data.userDetail.userTokenDetail.jwtToken
          );
          localStorage.setItem(
            "roleId",
            JSON.stringify(res.data.userDetail.role.id)
          );

          navigate("/trips");
          dispatch(setLoader(false));
        } else {
          toast.error(res.data.statusDescription.description);
          formik.setFieldValue("otpgen", false);
          setOtpSent(false);
        }
      });
    },
  });
  useEffect(() => {
    let interval;
    if (formik.values.otpgen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setOtpSent(false);
    }
    return () => clearInterval(interval);
  }, [formik.values.otpgen, timer]);

  // const verifyOtp = async () => {
  //   if (timer == 0) {
  //     toast.warn("OTP expired");
  //     return;
  //   }
  //   if (!formik.values.otp) return toast.warn("OTP is required");
  //   let formdata = {
  //     usernameOrEmail: formik.values.usernameOrEmail,
  //     otp: formik.values.otp,
  //   };
  //   try {
  //     dispatch(setLoader(true));
  //     await otpVerify(formdata).then((res) => {
  //       // console.log(res);

  //       if (res && res.data.statusDescription.statusCode == 200) {
  //         localStorage.setItem("user", JSON.stringify(res.data.userDetail));
  //         dispatch(setUserData(res.data.userDetail));
  //         dispatch(setisLoginUser(true));
  //         dispatch(setToken(res.data.userDetail.userTokenDetail.jwtToken));

  //         common_axios.defaults.headers.common[
  //           "Authorization"
  //         ] = `Bearer ${res.data.userDetail.userTokenDetail.jwtToken}`;
  //         common_axios.defaults.headers.common["userId"] =
  //           res.data.userDetail.userId;
  //         common_axios.defaults.headers.common["jwtToken"] =
  //           res.data.userDetail.userTokenDetail.jwtToken;
  //         common_axios.defaults.headers["source"] = "1";
  //         common_axios.defaults.headers["appVersion"] = "0";

  //         localStorage.setItem(
  //           "userId",
  //           JSON.stringify(res.data.userDetail.userId)
  //         );
  //         localStorage.setItem(
  //           "token",
  //           res.data.userDetail.userTokenDetail.jwtToken
  //         );
  //         localStorage.setItem(
  //           "roleId",
  //           JSON.stringify(res.data.userDetail.role.id)
  //         );

  //         navigate("/trips");
  //         dispatch(setLoader(false));
  //       } else {
  //         toast.error(res.data.statusDescription.description);
  //         dispatch(setLoader(false));
  //       }
  //     });
  //   } catch (e) {
  //     // console.log(e);
  //   }
  // };

  const verifyOtp = async () => {
    if (timer === 0) {
      toast.warn("OTP expired");
      return;
    }

    if (!formik.values.otp) {
      toast.warn("OTP is required");
      return;
    }

    const formdata = {
      usernameOrEmail: formik.values.usernameOrEmail,
      otp: formik.values.otp,
    };

    try {
      dispatch(setLoader(true));

      const res = await otpVerify(formdata);

      if (res && res.data.statusDescription.statusCode === 200) {
        const userDetail = res.data.userDetail;
        const token = userDetail.userTokenDetail.jwtToken;
        const userId = userDetail.userId;
        const roleId = userDetail.role.id;

        // Store in localStorage
        localStorage.setItem("user", JSON.stringify(userDetail));
        localStorage.setItem("userId", JSON.stringify(userId));
        localStorage.setItem("token", token);
        localStorage.setItem("roleId", JSON.stringify(roleId));

        // Dispatch to Redux
        dispatch(setUserData(userDetail));
        dispatch(setisLoginUser(true));
        dispatch(setToken(token));

        // Set Axios defaults
        common_axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        common_axios.defaults.headers.common["userId"] = userId;
        common_axios.defaults.headers.common["jwtToken"] = token;
        common_axios.defaults.headers["source"] = "1";
        common_axios.defaults.headers["appVersion"] = "0";

        // ✅ Redirect user based on role
        if (roleId === 1 || roleId === 2 || roleId === 5) {
          navigate("/dshbd");
        } else if (roleId === 3) {
          navigate("/addFuelDetails");
        } else if (roleId === 4) {
          navigate("/trips");
        } else {
          toast.error("Invalid role. Contact admin.");
        }

      } else {
        toast.error(res?.data?.statusDescription?.description || "OTP verification failed");
      }
    } catch (e) {
      console.error("OTP verification error:", e);
      toast.error("Something went wrong. Please try again.");
    } finally {
      dispatch(setLoader(false));
    }
  };


  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-content">
          <img
            src="altruist_technologies_pvt_ltd_logo.png"
            alt="Mining Portal"
            className="login-logo"
          />
          <h1>Welcome to Mining Portal</h1>
          <p>Enter your credentials to access your account</p>
        </div>
      </div>
      <div className="login-right">
        <div className="login-form-container">
          <h2>Login</h2>
          <form onSubmit={formik.handleSubmit}>
            {formik.values.otpgen ? (
              <span>
                <div className="form-group">
                  <div className="input-group">
                    <TextField
                      type="number"
                      label="OTP"
                      name="otp"
                      value={formik.values.otp}
                      onChange={(e) => {
                        if (e.target.value.length <= 6) {
                          formik.handleChange(e);
                        }
                      }}
                      placeholder="Enter OTP"
                      fullWidth
                    />
                    {/* <i className="fas fa-envelope"></i> */}
                  </div>
                </div>
                <div className="form-group remember-forgot d-flex justify-content-end">
                  <label className="remember-me" style={{ display: "none" }}>
                    <input type="checkbox" style={{ display: "none" }} />{" "}
                    <span className="remember" style={{ display: "none" }}>
                      Remember me
                    </span>
                  </label>
                  {otpSent ? (
                    <p>{timer}</p>
                  ) : (
                    <a
                      onClick={formik.handleSubmit}
                      className="forgot-password"
                    >
                      Regenerate OTP
                    </a>
                  )}
                </div>
                <button
                  type="button"
                  className="login-btn"
                  onClick={(e) => {
                    verifyOtp();
                  }}
                >
                  Verify OTP <i className="fas fa-arrow-right"></i>
                </button>
              </span>
            ) : (
              <span>
                <div className="form-group labl_div">
                  {/* <div className="input-group"> */}
                  <TextField
                    type="text"
                    label="Username/Email"
                    name="usernameOrEmail"
                    value={formik.values.usernameOrEmail}
                    onChange={formik.handleChange}
                    placeholder="Enter your email"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <i
                            className="fas fa-envelope"
                            style={{ color: "#555" }}
                          ></i>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <i className="fas fa-envelope"></i>
                  {/* </div> */}
                </div>
                <div className="form-group pswd_div">
                  {/* <div className="input-group"> */}
                  <TextField
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    className="position-relative"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    placeholder="Enter password"
                    fullWidth
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            title={
                              showPassword ? "hide password" : "show password"
                            }
                            aria-label="toggle password visibility"
                            onClick={(e) => {
                              setShowPassword(!showPassword);
                            }}
                            onMouseDown={handleInputChange}
                          >
                            {showPassword ? (
                              <VisibilityIcon
                                className="position-absolute eye_icn"
                                sx={{ color: "#85CBF2" }}
                              />
                            ) : (
                              <VisibilityOffIcon
                                className="position-absolute eye_icn"
                                sx={{ color: "#85CBF2" }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),

                      startAdornment: (
                        <InputAdornment position="start">
                          <i className="fas fa-lock"></i>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* </div> */}
                </div>
                <div className="form-group remember-forgot">
                  <label className="remember-me">
                    <input type="checkbox" />{" "}
                    <span className="remember">Remember me</span>
                  </label>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/forgot");
                    }}
                    className="forgot-password"
                  >
                    Forgot Password?
                  </a>
                </div>
                <button type="submit" className="login-btn">
                  Login <i className="fas fa-arrow-right"></i>
                </button>
              </span>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
